/**
 * @param {*} v  月份和日期不足10补0
 */
function addZero(v) {
  return v < 10 ? "0" + v : v;
}

/**
 *
 * @param {*} time 格式化时间
 */
export function formatTime(time, format) {
  let formatTypeTime;
  const dateTime = new Date(time);
  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1;
  const date = dateTime.getDate();
  const hour = dateTime.getHours();
  const minute = dateTime.getMinutes();
  const second = dateTime.getSeconds();
  switch (format) {
    case "yyyy-MM-dd":
      formatTypeTime = `${year}-${addZero(month)}-${addZero(date)}`;
      break;
    case "yyyy-MM-dd HH:mm:ss":
      formatTypeTime = `${year}-${addZero(month)}-${addZero(date)} ${addZero(
        hour
      )}:${addZero(minute)}:${addZero(second)}`;
      break;
  }
  return formatTypeTime;
}
